import { render, staticRenderFns } from "./Instructions.vue?vue&type=template&id=48513f08"
import script from "./Instructions.vue?vue&type=script&setup=true&lang=js"
export * from "./Instructions.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports